import {
  Component,
  ElementRef,
  Input,
  ViewChild
  } from '@angular/core';
import { isBs3 } from '../utilities/ng2-bootstrap-config';
import { DatePickerInnerComponent } from './datepicker-inner.component';

@Component({
  selector: 'axis-daybtn,[axis-daybtn]',
  templateUrl: './daybtn.component.html'
})
export class AxisDayButtonComponent {
  @Input() dtz: any;
  @ViewChild('btn') btn: any;
  public datePicker: DatePickerInnerComponent;

  public constructor(
    datePicker: DatePickerInnerComponent,
    private el: ElementRef
  ) {
    this.datePicker = datePicker;
  }

  public get isBs4(): boolean {
    return !isBs3();
  }
}
